<template>
	<transition 
			name="custom-classes-transition" 
			:enter-active-class="$_chtLst_styleComponentAnimation()">
		<template v-if="$_chtLst_stateComponentIsInitialized">
			<v-list class="customVList" 
					expand
					:color="$_chtLst_styleListColor"
					:dark="$_chtLst_styleListDark"
					:dense="$_chtLst_styleListDense"
					:elevation="$_chtLst_styleListElevation"
					:flat="$_chtLst_styleListFlat"
					:light="$_chtLst_styleListLight"
					:nav="$_chtLst_styleListNav"
					:rounded="$_chtLst_styleListRounded"
					:shaped="$_chtLst_styleListShaped"
					:subheader="$_chtLst_styleListSubheader"
					:three-line="$_chtLst_styleListThreeLine"
					:tile="$_chtLst_styleListTile"
					:two-line="$_chtLst_styleListTwoLine">
				<v-list-group 
						v-model="isOpened_"
						no-action>
					<template v-slot:activator>
						<v-row no-gutters>
							<v-col>
								<v-subheader>
									<span	class="caption"
											v-html="$_chtLst_langTitle" />
								</v-subheader>
							</v-col>
						</v-row>
					</template>
					<!-- my chat -->
					<v-list-item
							class="customVListItem" 
							dense
							@click="$_chtLst_select(myChat_, 'myChat')">
						<v-list-item-icon class="customVListItemIcon">
							<v-icon  :color="componentState_.chatList.code == 'myChat' ? 'primary' : null">
								person_outline
							</v-icon>
						</v-list-item-icon>
						<v-list-item-title>
							<span	:class="componentState_.chatList.code == 'myChat' ? 'caption title_' : 'caption'"
									v-text="myChat_.name" />
						</v-list-item-title>
					</v-list-item>
					<!-- direct chat -->
					<template v-for="(directChatVals, directChatKey) in sortObject(directChats_, 'name')">
						<v-list-item
								:key="directChatKey"
								class="customVListItem" 
								dense
								@click="$_chtLst_select(directChatVals, directChatKey)">
							<v-list-item-icon class="customVListItemIcon">
								<v-icon  :color="componentState_.chatList.code == directChatKey ? 'primary' : null">
									person
								</v-icon>
							</v-list-item-icon>
							<v-list-item-title>
								<span	:class="componentState_.chatList.code == directChatKey ? 'caption title_' : 'caption'"
										v-text="directChatVals.name" />
							</v-list-item-title>
						</v-list-item>
					</template>
					<!-- group chat -->
					<template v-for="(groupChatVals, groupChatKey) in sortObject(groupChats_, 'name')">
						<v-list-item
								:key="groupChatKey"
								class="customVListItem" 
								dense
								@click="$_chtLst_select(groupChatVals, groupChatKey)">
							<v-list-item-icon class="customVListItemIcon">
								<v-icon  :color="componentState_.chatList.code == groupChatKey ? 'primary' : null">
									group
								</v-icon>
							</v-list-item-icon>
							<v-list-item-title>
								<span	:class="componentState_.chatList.code == groupChatKey ? 'caption title_' : 'caption'"
										v-text="groupChatVals.name" />
							</v-list-item-title>
						</v-list-item>
					</template>
				</v-list-group>
			</v-list>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'ChatList',
		data() {
			return {
				componentName_: 'chatList',

				myChat_: {
					name: 'My Chat',
					type: 'direct',
					status: 'joined'
				},

				directChats_: {
					admin: { 
						name: 'Admin',
						type: 'direct',
						status: 'joined'
					}
				},

				groupChats_: {},

				componentState_: {},
				
				isOpened_: true
			}
		},
		computed: {
			// current user
			$_chtLst_currentUserUid() {
				const self_ = this;
				return self_.getCurrentUser('uid')
			},
			// state
			$_chtLst_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			$_chtLst_stateComponentIsInitialized() {
				const self_ = this;
				return self_.getComponentState('isInitialized')
			},
			$_chtLst_stateComponentChatListKey() {
				const self_ = this;
				const chat_ = self_.getComponentState('chatList')
				if(self_.isEmpty(chat_)) { return null }
				return chat_.key
			},
			// contents / inits
			$_chtLst_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getComponentContents(self_.componentName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_chtLst_inits() {
				const self_ = this;
				return () => {
					return self_.getComponentInits(self_.componentName_)
				}
			},
			// lang
			$_chtLst_langTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_chtLst_inits(), 'title')
				return self_.getLangsVal(lang_)
			},
			// (content)
			$_chtLst_langContentGroupChatTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.title;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			// style
			$_chtLst_styleComponent() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_chtLst_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_chtLst_inits(), 'component')
				}
			},
			$_chtLst_styleComponentAnimation() {
				const self_ = this;
				return () => {
					const component_ = self_.$_chtLst_styleComponent()
					if(self_.isFalse(component_)) { return null }
					return self_.getStylesVal(component_.animation)
				}
			},
			$_chtLst_styleList() {
				const self_ = this;
				if(self_.isEmpty(self_.$_chtLst_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_chtLst_inits(), 'list')
			},
			$_chtLst_styleListColor() {
				const self_ = this;
				const list_ = self_.$_chtLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.color)
			},
			$_chtLst_styleListDark() {
				const self_ = this;
				const list_ = self_.$_chtLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.dark)
			},
			$_chtLst_styleListDense() {
				const self_ = this;
				const list_ = self_.$_chtLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.dense)
			},
			$_chtLst_styleListElevation() {
				const self_ = this;
				const list_ = self_.$_chtLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.elevation)
			},
			$_chtLst_styleListFlat() {
				const self_ = this;
				const list_ = self_.$_chtLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.flat)
			},
			$_chtLst_styleListLight() {
				const self_ = this;
				const list_ = self_.$_chtLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.light)
			},
			$_chtLst_styleListNav() {
				const self_ = this;
				const list_ = self_.$_chtLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.nav)
			},
			$_chtLst_styleListRounded() {
				const self_ = this;
				const list_ = self_.$_chtLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.rounded)
			},
			$_chtLst_styleListShaped() {
				const self_ = this;
				const list_ = self_.$_chtLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.shaped)
			},
			$_chtLst_styleListSubheader() {
				const self_ = this;
				const list_ = self_.$_chtLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.subheader)
			},
			$_chtLst_styleListThreeLine() {
				const self_ = this;
				const list_ = self_.$_chtLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.threeLine)
			},
			$_chtLst_styleListTile() {
				const self_ = this;
				const list_ = self_.$_chtLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.tile)
			},
			$_chtLst_styleListTwoLine() {
				const self_ = this;
				const list_ = self_.$_chtLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.twoLine)
			}
		},
		beforeMount() {
			const self_ = this;
			// initialize chats
			self_.$_chtLst_initializeChats()

			self_.componentState_ = self_.getState('component')
		},
		methods: {
			$_chtLst_initializeChats() {
				const self_ = this;

				const uid_ = self_.$_chtLst_currentUserUid;

				// Promise.resolve().then(() => {
				// 	return self_.getUserChatData(uid_)
				// }).then(result => {
				// 	if(self_.isEmpty(result)) { return }

				// 	Object.keys(result).forEach(row => {
				// 		const code_ = row['chat_code']
				// 		const name_ = row['chat_name']
				// 		const type_ = row['chat_type']

				//		const chat_ = {
				// 			name: name_,
				// 			type: type_,
				// 			status: status_
				// 		}

				// 		if(type_ == 'direct') { self_.directChats_[code_] = chat_; }
				// 		if(type_ == 'group') { self_.groupChats_[code_] = chat_; }
				// 	})
				// })
			},
			$_chtLst_select(chatVals, chatKey) {
				const self_ = this;

				const chatList_ = self_.getComponentState('chatList')
				const code_ = chatList_.code;

				if(code_ == chatKey) {
					const cleared_ = {
						code: null,
						name: null,
						type: null
					}
					self_.setComponentState('chatList', cleared_)
				} else {
					const new_ = {
						code: chatKey,
						name: chatVals.name,
						type: chatVals.type
					}
					self_.setComponentState('chatList', new_)
				}
			}
		}
	}
</script>

<style scoped>
	.title_ {
		color: #1976d2;
	}
</style>